/* */ 
"use strict";
var Report = require('./Report');
var SchemaCache = require('./SchemaCache');
var Utils = require('./Utils');
function mergeReference(scope, ref) {
  if (Utils.isAbsoluteUri(ref)) {
    return ref;
  }
  var joinedScope = scope.join(""),
      isScopeAbsolute = Utils.isAbsoluteUri(joinedScope),
      isScopeRelative = Utils.isRelativeUri(joinedScope),
      isRefRelative = Utils.isRelativeUri(ref),
      toRemove;
  if (isScopeAbsolute && isRefRelative) {
    toRemove = joinedScope.match(/\/[^\/]*$/);
    if (toRemove) {
      joinedScope = joinedScope.slice(0, toRemove.index + 1);
    }
  } else if (isScopeRelative && isRefRelative) {
    joinedScope = "";
  } else {
    toRemove = joinedScope.match(/[^#/]+$/);
    if (toRemove) {
      joinedScope = joinedScope.slice(0, toRemove.index);
    }
  }
  var res = joinedScope + ref;
  res = res.replace(/##/, "#");
  return res;
}
function collectReferences(obj, results, scope, path) {
  results = results || [];
  scope = scope || [];
  path = path || [];
  if (typeof obj !== "object" || obj === null) {
    return results;
  }
  if (typeof obj.id === "string") {
    scope.push(obj.id);
  }
  if (typeof obj.$ref === "string" && typeof obj.__$refResolved === "undefined") {
    results.push({
      ref: mergeReference(scope, obj.$ref),
      key: "$ref",
      obj: obj,
      path: path.slice(0)
    });
  }
  if (typeof obj.$schema === "string" && typeof obj.__$schemaResolved === "undefined") {
    results.push({
      ref: mergeReference(scope, obj.$schema),
      key: "$schema",
      obj: obj,
      path: path.slice(0)
    });
  }
  var idx;
  if (Array.isArray(obj)) {
    idx = obj.length;
    while (idx--) {
      path.push(idx.toString());
      collectReferences(obj[idx], results, scope, path);
      path.pop();
    }
  } else {
    var keys = Object.keys(obj);
    idx = keys.length;
    while (idx--) {
      if (keys[idx].indexOf("__$") === 0) {
        continue;
      }
      path.push(keys[idx]);
      collectReferences(obj[keys[idx]], results, scope, path);
      path.pop();
    }
  }
  if (typeof obj.id === "string") {
    scope.pop();
  }
  return results;
}
var compileArrayOfSchemasLoop = function(mainReport, arr) {
  var idx = arr.length,
      compiledCount = 0;
  while (idx--) {
    var report = new Report(mainReport);
    var isValid = exports.compileSchema.call(this, report, arr[idx]);
    if (isValid) {
      compiledCount++;
    }
    mainReport.errors = mainReport.errors.concat(report.errors);
  }
  return compiledCount;
};
function findId(arr, id) {
  var idx = arr.length;
  while (idx--) {
    if (arr[idx].id === id) {
      return arr[idx];
    }
  }
  return null;
}
var compileArrayOfSchemas = function(report, arr) {
  var compiled = 0,
      lastLoopCompiled;
  do {
    var idx = report.errors.length;
    while (idx--) {
      if (report.errors[idx].code === "UNRESOLVABLE_REFERENCE") {
        report.errors.splice(idx, 1);
      }
    }
    lastLoopCompiled = compiled;
    compiled = compileArrayOfSchemasLoop.call(this, report, arr);
    idx = arr.length;
    while (idx--) {
      var sch = arr[idx];
      if (sch.__$missingReferences) {
        var idx2 = sch.__$missingReferences.length;
        while (idx2--) {
          var refObj = sch.__$missingReferences[idx2];
          var response = findId(arr, refObj.ref);
          if (response) {
            refObj.obj["__" + refObj.key + "Resolved"] = response;
            sch.__$missingReferences.splice(idx2, 1);
          }
        }
        if (sch.__$missingReferences.length === 0) {
          delete sch.__$missingReferences;
        }
      }
    }
  } while (compiled !== arr.length && compiled !== lastLoopCompiled);
  return report.isValid();
};
exports.compileSchema = function(report, schema) {
  report.commonErrorMessage = "SCHEMA_COMPILATION_FAILED";
  if (typeof schema === "string") {
    var loadedSchema = SchemaCache.getSchemaByUri.call(this, report, schema);
    if (!loadedSchema) {
      report.addError("SCHEMA_NOT_REACHABLE", [schema]);
      return false;
    }
    schema = loadedSchema;
  }
  if (Array.isArray(schema)) {
    return compileArrayOfSchemas.call(this, report, schema);
  }
  if (schema.__$compiled && schema.id && SchemaCache.checkCacheForUri.call(this, schema.id) === false) {
    schema.__$compiled = undefined;
  }
  if (schema.__$compiled) {
    return true;
  }
  if (schema.id && typeof schema.id === "string") {
    SchemaCache.cacheSchemaByUri.call(this, schema.id, schema);
  }
  var isRoot = false;
  if (!report.rootSchema) {
    report.rootSchema = schema;
    isRoot = true;
  }
  var isValidExceptReferences = report.isValid();
  delete schema.__$missingReferences;
  var refs = collectReferences.call(this, schema),
      idx = refs.length;
  while (idx--) {
    var refObj = refs[idx];
    var response = SchemaCache.getSchemaByUri.call(this, report, refObj.ref, schema);
    if (!response) {
      var schemaReader = this.getSchemaReader();
      if (schemaReader) {
        var s = schemaReader(refObj.ref);
        if (s) {
          s.id = refObj.ref;
          var subreport = new Report(report);
          if (!exports.compileSchema.call(this, subreport, s)) {
            report.errors = report.errors.concat(subreport.errors);
          } else {
            response = SchemaCache.getSchemaByUri.call(this, report, refObj.ref, schema);
          }
        }
      }
    }
    if (!response) {
      var hasNotValid = report.hasError("REMOTE_NOT_VALID", [refObj.ref]);
      var isAbsolute = Utils.isAbsoluteUri(refObj.ref);
      var isDownloaded = false;
      var ignoreUnresolvableRemotes = this.options.ignoreUnresolvableReferences === true;
      if (isAbsolute) {
        isDownloaded = SchemaCache.checkCacheForUri.call(this, refObj.ref);
      }
      if (hasNotValid) {} else if (ignoreUnresolvableRemotes && isAbsolute) {} else if (isDownloaded) {} else {
        Array.prototype.push.apply(report.path, refObj.path);
        report.addError("UNRESOLVABLE_REFERENCE", [refObj.ref]);
        report.path = report.path.slice(0, -refObj.path.length);
        if (isValidExceptReferences) {
          schema.__$missingReferences = schema.__$missingReferences || [];
          schema.__$missingReferences.push(refObj);
        }
      }
    }
    refObj.obj["__" + refObj.key + "Resolved"] = response;
  }
  var isValid = report.isValid();
  if (isValid) {
    schema.__$compiled = true;
  } else {
    if (schema.id && typeof schema.id === "string") {
      SchemaCache.removeFromCacheByUri.call(this, schema.id);
    }
  }
  if (isRoot) {
    report.rootSchema = undefined;
  }
  return isValid;
};
